import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
import SonyaManips from '../../components/Suikoden/SonyaManip';
import SonyaData from '../../lib/Suikoden/Sonya/AnyPercent.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Suikoden Any% Sonya Tool" mdxType="SEO" />
    <SonyaManips data={SonyaData} showSeed={true} mdxType="SonyaManips" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      